let count = 0;

export const generateId = () => (count++).toString();
